module.exports = __webpack_public_path__ + "static/img/technology.7ea58e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/technology.png
// module id = gM45
// module chunks = 21